import React, { Component } from 'react';
import './ProcurementAllocation.css';

class ProcurementAllocation extends Component {
    // Helper function to convert ISO date string to YYYY-MM-DD format
    formatDateForInput = (isoDateString) => {
        if (!isoDateString) return '';
        try {
            const date = new Date(isoDateString);
            return date.toISOString().split('T')[0];
        } catch (error) {
            console.error('Error formatting date:', error);
            return '';
        }
    };

    constructor(props) {
        super(props);
        
        // Process the procurement allocation data to format dates properly
        let procurementAllocationExisting = this.props.procurementAllocation;
        
        if (procurementAllocationExisting && procurementAllocationExisting.length > 0) {
            // Format dates for existing data
            procurementAllocationExisting = procurementAllocationExisting.map(allocation => ({
                ...allocation,
                startDate: this.formatDateForInput(allocation.startDate),
                endDate: this.formatDateForInput(allocation.endDate)
            }));
        } else {
            // Default data if no props provided
            procurementAllocationExisting = [
                {
                    procurementAllocationId: Math.floor(Date.now()),
                    startDate: '',
                    endDate: '',
                    rows: [
                        {
                            procurementAllocationRowId: Math.floor(Date.now()) + Math.random(),
                            fundEntityId:  null,
                            allocationPercentage: null
                        }
                    ]
                }
            ];
        }
        this.state = {
            procurementAllocationExisting: procurementAllocationExisting,
            procurementAllocation: procurementAllocationExisting,
            fundEntityList: this.props.fundEntityList ?? []
        };
        //console.log("fundEntityList:", this.state.fundEntityList);
        this.resetData = this.resetData.bind(this);
    }

    resetData = () => {
        this.setState({
            procurementAllocation: this.state.procurementAllocationExisting
        });
    }

    // Notify parent component whenever data changes
    notifyParent = () => {
        if (this.props.onDataChange) {
            this.props.onDataChange(this.state.procurementAllocation);
        }
    };

    // Date Range Operations with parent notification
    addDateRange = () => {
        const newDateRange = {
            procurementAllocationId: Math.floor(Date.now()),
            startDate: '',
            endDate: '',
            rows: [
                {
                    procurementAllocationRowId: Math.floor(Date.now()) + Math.random(),
                    fundEntityId:  null,
                    allocationPercentage: null
                }
            ]
        };
        
        this.setState({
            procurementAllocation: [...this.state.procurementAllocation, newDateRange]
        }, () => {
            this.notifyParent(); // Callback after setState completes
        });
    };

    removeDateRange = (dateRangeId) => {
        this.setState({
            procurementAllocation: this.state.procurementAllocation.filter(dr => dr.procurementAllocationId !== dateRangeId)
        }, () => {
            this.notifyParent();
        });
    };

    updateDateRange = (dateRangeId, field, value) => {
        this.setState({
            procurementAllocation: this.state.procurementAllocation.map(dr =>
                dr.procurementAllocationId === dateRangeId ? { ...dr, [field]: value } : dr
            )
        }, () => {
            this.notifyParent();
        });
    };

    // Row Operations with parent notification
    addRow = (dateRangeId) => {
        const newRow = {
            procurementAllocationRowId: Math.floor(Date.now()) + Math.random(),
            fundEntityId:  null,
            allocationPercentage: null
        };
        
        this.setState({
            procurementAllocation: this.state.procurementAllocation.map(dr =>
                dr.procurementAllocationId === dateRangeId
                    ? { ...dr, rows: [...dr.rows, newRow] }
                    : dr
            )
        }, () => {
            this.notifyParent();
        });
    };

    removeRow = (dateRangeId, rowId) => {
        this.setState({
            procurementAllocation: this.state.procurementAllocation.map(dr =>
                dr.procurementAllocationId === dateRangeId
                    ? { ...dr, rows: dr.rows.filter(row => row.procurementAllocationRowId !== rowId) }
                    : dr
            )
        }, () => {
            this.notifyParent();
        });
    };

    updateRow = (dateRangeId, rowId, field, value) => {
        // Validate decimal input for amount field
        if (field === 'amount') {
            const decimalRegex = /^\d*\.?\d*$/;
            if (!decimalRegex.test(value)) {
                return;
            }
        }

        this.setState({
            procurementAllocation: this.state.procurementAllocation.map(dr =>
                dr.procurementAllocationId === dateRangeId
                    ? {
                        ...dr,
                        rows: dr.rows.map(row =>
                            row.procurementAllocationRowId === rowId ? { ...row, [field]: value } : row
                        )
                    }
                    : dr
            )
        }, () => {
            this.notifyParent();
        });
    };

    // Method to expose data to parent on demand
    getData = () => {
        return this.state.procurementAllocation;
    };

    // Register this method with parent component
    componentDidMount() {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
    }

    componentDidUpdate(prevProps) {
        // Update state when props change (e.g., when new data is loaded)
        if (prevProps.procurementAllocation !== this.props.procurementAllocation) {
            let procurementAllocationExisting = this.props.procurementAllocation;
            
            if (procurementAllocationExisting && procurementAllocationExisting.length > 0) {
                // Format dates for new data
                procurementAllocationExisting = procurementAllocationExisting.map(allocation => ({
                    ...allocation,
                    startDate: this.formatDateForInput(allocation.startDate),
                    endDate: this.formatDateForInput(allocation.endDate)
                }));
            } else {
                // Default data if no props provided
                procurementAllocationExisting = [
                    {
                        procurementAllocationId: Math.floor(Date.now()),
                        startDate: '',
                        endDate: '',
                        rows: [
                            {
                                procurementAllocationRowId: Math.floor(Date.now()) + Math.random(),
                                fundEntityId:  null,
                                allocationPercentage: null
                            }
                        ]
                    }
                ];
            }
            
            this.setState({
                procurementAllocationExisting: procurementAllocationExisting,
                procurementAllocation: procurementAllocationExisting
            });
        }
    }

    componentWillUnmount() {
        if (this.props.onRef) {
            this.props.onRef(null);
        }
    }

    // Rest of your render method remains the same...
    render() {
        return (
            <div className="nested-grid-container">
                {this.state.procurementAllocation.map((dateRange, index) => (
                    <div key={dateRange.procurementAllocationId} className="date-range-section">                        
                        <div className="date-inputs">
                        </div>

                        <div className="rows-section">
                            <div className="rows-header">
                                <h5><label title='Finance Team will update allocations, whether Fund Expense, Management Expense or Shared Expense' className="fsBig"><b>Procurement Allocation (Fund / Management / Shared)</b></label></h5>
                                <button 
                                    className="btn btn-success btn-sm"
                                    onClick={() => this.addRow(dateRange.procurementAllocationId)}
                                >
                                    Add Row
                                </button>
                            </div>

                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th><label title='Please select the Fund/Entity.' className="fsBig"><b>Fund/Entity</b></label></th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dateRange.rows.map((row) => (
                                        <tr key={row.procurementAllocationRowId}>
                                            <td>
                                                <select
                                                    value={row.fundEntityId}
                                                    onChange={(e) => this.updateRow(
                                                        dateRange.procurementAllocationId,
                                                        row.procurementAllocationRowId,
                                                        'fundEntityId',
                                                        e.target.value
                                                    )}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Fund Entity</option>
                                                    {this.props.fundEntityList.map((entity, idx) => (
                                                        <option key={idx} value={entity.value || entity}>
                                                            {entity.text || entity}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => this.removeRow(dateRange.procurementAllocationId, row.procurementAllocationRowId)}
                                                    disabled={dateRange.rows.length === 1}>
                                                    Remove
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default ProcurementAllocation;
